import { ResponsiveBody } from 'component-library/components/typography/ResponsiveBody';
import { Subheading } from 'component-library/components/typography/Subheading';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

export const EmptyChart = () => (
  <>
    <Subheading variant={1} marginBottom={16}>
      Calculate your retirement income
    </Subheading>
    <ResponsiveBody variant={4}>
      Retirable’s retirement calculator helps to project how much monthly
      retirement income your retirement nest egg can produce while ensuring your
      savings last as long as you need.
    </ResponsiveBody>
    <StaticImage src="../images/empty-chart.png" alt="Grayed out chart" />
  </>
);
